import { render, staticRenderFns } from "./datepickerrange.vue?vue&type=template&id=f8505c52&"
import script from "./datepickerrange.vue?vue&type=script&lang=js&"
export * from "./datepickerrange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports